<div class="content-wrapper">
	<div class="container animated fadeIn">
		<div class="row justify-content-center">
			<div class="mt-5 d-flex align-items-center">
				<div class="display-4">Bem-vindo ao</div>
				<div class="app-logo ms-2">
					<h3 class="mb-0">FlexCash</h3>
				</div>
			</div>
		</div>
		<div class="row big-space mb-5">
			<div class="col-xl-4 mt-sm-3">
				<div class="cool-box">
					<div class="title">
						<div>Version 6.9.8.1 is ready</div>
					</div>
					<div class="content">
						<div class="d-flex justify-content-center p-5">
							<div class="icon-img color-1">
								<i class="fa-light fa-code-merge fa-fw"></i>
							</div>
						</div>
					</div>
					<div class="footer">
						<div class="linkInEvidence d-flex justify-content-center">
							<div>
								<a href="#">You can check all the new features in this link</a>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="col-xl-4 mt-sm-3">
				<div class="cool-box">
					<div class="title">
						<div>Contacts</div>
					</div>
					<div class="content">
						<div class="d-flex align-items-center p-5 flex-column">
							<div class="icon-img color-2">
								<i class="fa-light fa-envelope fa-fw"></i>
							</div>
						</div>
					</div>
					<div class="footer">
						<div class="d-flex justify-content-center">
							<div>
								<a href="mailto:{{ 'help.email.support.email' | translate }}">Send us your opinion</a>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="col-xl-4 mt-sm-3">
				<div class="cool-box">
					<div class="title">
						<div>Login</div>
					</div>
					<div class="content">
						<div class="d-flex justify-content-center p-5">
							<div class="icon-img color-3">
								<i class="fa-light fa-sign-in fa-fw"></i>
							</div>
						</div>
					</div>
					<div class="footer">
						<div class="linkInEvidence d-flex justify-content-center">
							<div>
								<a
									href=""
									[routerLink]="['/public/login']"
									>Click here for login</a
								>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
